"use client";

export const SelectOption = ({
  children,
  value,
  disabled = false,
  ...rest
}: SelectOptionProps) => {
  return (
    <option value={value} disabled={disabled} {...rest}>
      {children}
    </option>
  );
};

export type SelectOptionProps = {
  children: React.ReactNode;
  value: string;
  disabled?: boolean;
} & React.OptionHTMLAttributes<HTMLOptionElement>;
